import {matchSorter} from 'match-sorter';
import React, { useState } from "react";

function fuzzyTextFilterFn(rows, id, filterValue) {
    return matchSorter(rows, filterValue, { keys: [row => row.values[id]] });
  }

export default fuzzyTextFilterFn;